import { render, staticRenderFns } from "./VideoCallNotifyMessage.vue?vue&type=template&id=6f53dc90&"
import script from "./VideoCallNotifyMessage.vue?vue&type=script&lang=ts&"
export * from "./VideoCallNotifyMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports